import React, {useEffect, useState} from 'react';
import Accordion from "react-bootstrap/Accordion";
import {Card} from "react-bootstrap";
import TableConfigItem from "./TableConfigItem";
import {useAccordionButton} from "react-bootstrap/AccordionButton";
import arrowUp from "../../images/arrow-up.png";
import arrowDown from "../../images/arrow-down.png";
import {Table} from "antd";
import {joinData, mapDynamicTableHeader} from "../Installations/tableHelperFuntions";
import {useDispatch, useSelector} from "react-redux";
import {getDynamicTableById, installationSelectData, locationsSelectData} from "../../redux-store/selectors";
import {getDynamicTableAndLocations} from "../../redux-store/dynamicTable";

function TableConfigDetailView({id}) {

    const {selected} = useSelector(installationSelectData)
    const table = useSelector(getDynamicTableById(id))

    const {options} = useSelector(locationsSelectData)

    const dispatch = useDispatch()

    const [activeEventKey, setActiveEventKey] = useState(0);

    useEffect(() => {
        dispatch(getDynamicTableAndLocations({
            installationId: selected.value,
            tableId: id,
        }))
    }, [])

    const handleTableChange = (newPagination) => {
        dispatch(getDynamicTableAndLocations({installationId: selected.value, tableId: id, pagination: newPagination}))
    }

    function CustomToggle({eventKey}) {
        const decoratedOnClick = useAccordionButton(eventKey, () => {
            if (activeEventKey === eventKey) setActiveEventKey(0); else {
                setActiveEventKey(eventKey);
            }
        });
        if (eventKey === activeEventKey) return <img src={arrowUp} width={20} height={20} onClick={decoratedOnClick}/>
        return <img src={arrowDown} width={20} height={20} onClick={decoratedOnClick}/>
    }

    return (<>
        <Accordion>
            <Card key={table.id}>
                <Card.Header>
                    <div className={"d-flex align-items-center"}>
                        <CustomToggle eventKey={table.id}>Click me!</CustomToggle>
                        <div className={"d-flex justify-content-between w-100 align-items-baseline"}>
                            <span className={"device-accordion-title"}>{table.name}</span>
                        </div>
                    </div>
                    <div>
                        <span className={"ms-4 text-muted"}>{table.description}</span>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={table.id}>
                    <Card.Body style={{overflow: "auto"}}>
                        {options?.length &&
                            <TableConfigItem id={id}>
                                <Table
                                    columns={mapDynamicTableHeader(table.columns, table.id, selected.value)}
                                    className={"bl-test"}
                                    rowKey={(record) => {
                                        if (record[Object.keys(record)[0]]?.rowId) {
                                            return record[Object.keys(record)[0]]?.rowId
                                        } else {
                                            return record.location.id
                                        }
                                    }}
                                    dataSource={joinData(table, options, mapDynamicTableHeader(table.columns))}
                                    onChange={handleTableChange}
                                    pagination={table.pagination}
                                    showSizeChanger={false}
                                />
                            </TableConfigItem>}
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    </>);
}

export default TableConfigDetailView;